import Api from "@/services/Api";
import SystemConst from "@/config/const";

export default {
  createPurchasedTicket(params: any) {
    return Api().post(
      `users/purchased_tickets/${params.ticket_id}/complete`,
      params
    );
  },

  getPurchasedTicket(purchased_ticket_id: number | string) {
    return Api().get(`users/purchased_tickets/${purchased_ticket_id}`);
  },

  usePurchasedTicket(purchased_ticket_id: number | string) {
    return Api().put(
      `users/purchased_tickets/${purchased_ticket_id}/use_service`
    );
  },

  cancelPurchasedTicket(purchased_ticket_id: number | string) {
    return Api().put(
      `users/purchased_tickets/${purchased_ticket_id}/cancel_service`
    );
  },

  getPurchasedTickets(query: any) {
    let url = `/users/purchased_tickets?page=${query.page}&per_page=${query.per_page}`;
    if (
      query.ticket_type &&
      query.ticket_type !== SystemConst.TICKET_TYPE_ALL
    ) {
      url += `&ticket_type=${query.ticket_type}`;
    }
    if (
      query.status &&
      query.status !== SystemConst.PURCHASED_TICKET_STATUS_ALL
    ) {
      url += `&status=${query.status}`;
    }
    return Api().get(url);
  }
  // checkCompletePurchasedTicket(params: any) {
  //   return Api().post(
  //     `users/purchased_tickets/${params.ticket_id}/complete`,
  //     params
  //   );
  // }
};
